export default __webpack_public_path__ + "static/media/empty-do.60257126.svg";